export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-comment-minus-60735cb0ae78643620c6102cd515408a.svg";